package org.teddapp.project.ui.mindmap

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.drawscope.scale
import androidx.compose.ui.graphics.drawscope.translate
import androidx.compose.ui.graphics.layer.GraphicsLayer
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.LayoutDirection
import kotlin.math.max
import kotlin.math.min

/**
 * La carte en image : toute l'étendue de l'arbre tel qu'il est plié, à l'échelle 1,
 * indépendamment du zoom et du défilement de l'écran. Un plafond de 4 096 px par
 * côté protège la mémoire du téléphone et du navigateur.
 */
internal suspend fun exportMindMapImage(
    layer: GraphicsLayer,
    layout: MindMapLayoutResult,
    painter: MindMapPainter,
    density: Density,
    background: Color,
    noteCounts: Map<String, Int>,
): ImageBitmap {
    val margin = 48f
    val bounds = layout.bounds.toCompose()
    val w = bounds.width + 2 * margin
    val h = bounds.height + 2 * margin
    val k = min(1f, MAX_SIDE / max(w, h))
    layer.record(density, LayoutDirection.Ltr, IntSize((w * k).toInt().coerceAtLeast(1), (h * k).toInt().coerceAtLeast(1))) {
        drawRect(background)
        scale(k, k, Offset.Zero) {
            translate(margin - bounds.left, margin - bounds.top) {
                with(painter) {
                    drawMindMap(
                        layout = layout,
                        visible = Rect(bounds.left - margin, bounds.top - margin, bounds.right + margin, bounds.bottom + margin),
                        scale = 1f,
                        marks = MindMapPainter.Marks(noteCounts = noteCounts),
                        rectOf = { it.rect.toCompose() },
                        alphaOf = { 1f },
                    )
                }
            }
        }
    }
    return layer.toImageBitmap()
}

private const val MAX_SIDE = 4096f

/** « carte-heuristique-apache-kafka.png » */
internal fun exportFileName(title: String): String {
    val slug = title.lowercase()
        .map { c -> if (c.isLetterOrDigit()) c else '-' }
        .joinToString("")
        .replace(Regex("-+"), "-")
        .trim('-')
        .take(40)
        .ifEmpty { "carte" }
    return "carte-heuristique-$slug.png"
}
